<template>
 <div class="app" v-title data-title="富林印迹-广富林文化遗址公园">
    <component :is="headerComponent" :activeIndex="1" />
     <div class="yj-banner rel">
      <img src="@/assets/images/yj-banner.png" class="db wp100" alt="banner">
      <div class="crumbs-nav df align_center justify_end fa_wh box-border">
        <router-link to="/" class="f16 fw">首页</router-link>
        <img src="@/assets/images/arrow-wh-05.png" class="db w20 ml5 mr5" alt="">
        <router-link to="/pages/yinxiang/index" class="f16 fw">印象富林</router-link>
        <img src="@/assets/images/arrow-wh-05.png" class="db w20 ml5 mr5" alt="">
        <router-link to="/pages/yuding/food" class="f16 fw">富林美食</router-link>
      </div>
      <div class="yj-banner-tit df align_center flex_column justify_center ts fw">
        <div class="f50 ls1 b">印象富林</div>
        <div class="f17 ls3">Impressions of Guangfulin</div>
      </div>
    </div>
<div class="spot-cont mt-40 pb50">
      <div class="spot-tit spot-view-tit df align_center justify_center">
        <h2 class="f32 foo pb50" v-if="detailInfo && detailInfo.Name">{{ detailInfo.Name }}</h2>
      </div>
      <div class="spot-intro f16 tc mt15" v-if="detailInfo && detailInfo.SubTitle" v-html="detailInfo.SubTitle"></div>
      <div class=" w1200 auto pb15 yinxiang-yizhi-text cell_bk mt50 f16 foo lh18 tj" v-if="detailInfo && detailInfo.Intro" v-html="detailInfo.Intro">
      </div>
      <div class="auto pb15 yinxiang-yizhi-text cell_bk mt50 f16 foo lh18 tj" v-if="detailInfo && detailInfo.Photo">
        <img :src="detailInfo.Photo + '!/both/800x400'">
      </div>
 </div>
   <!-- <div class="spot-other mt50 pb50">
        <div class="spot-tit df align_center justify_center">
          <h2 class="f32 foo pb15">更多美食</h2>
        </div>
        <div class="spot-item df flex_wrap w1200 auto pt20" v-if="otherSenic && otherSenic.length > 0">
          <div class="spot-box wp33" v-for="item in otherSenic" :key="item.Id">
            <router-link :to="'/pages/yuding/food-view?id=' + item.Id" class="db rel ml12 mr12 mt24 spot-link">
              <img v-if="item.Photo" :src="item.Photo + '!/both/752x1002'" class="db wp100" alt="">
              <div class="spot-box-text df align_center justify_center">
                <span class="fw f18 spot-box-text-name" v-if="item.Name">{{ item.Name }}</span>
              </div>
            </router-link>
          
          </div>
        </div>
      </div> -->
    <component :is="bottomComponent" />
 </div>

</template>
<script>
import Header from '../../components/header.vue'
import Bottom from '../../components/bottom.vue'
import restaurantService from '@/services/client/cont/restaurant'

export default {
  name: 'app',
  data () {
    return {
      headerComponent: 'Header',
      bottomComponent: 'Bottom',
      aMapComponent: 'amap',
      filter: {
        Page: 1,
        PageSize: 3,
        Type: 1,
      },
      otherSenic: null,
      detailId: null,
      detailInfo: null,
    }
  },
  components: { Header, Bottom},
  watch: {
    '$route': {
      handler(to, from) {
        this.initPage();
      }
    }
  },
  mounted() {
    window.scrollTo(0,0);
    this.initPage();
   
  },
  methods:{
    initPage() {
      if(this.$route.query && this.$route.query.id) {
        this.detailId = this.$route.query.id;
      }
      this.loadData();
      this.loadOtherSenic();
    },
    loadData() {
      this.detailInfo = null;
      restaurantService.detail(this.detailId).then(res => {
        if(res.Code == 200 && res.Data) {
          this.detailInfo = res.Data;
        }
      })
    },
    loadOtherSenic() {
      this.otherSenic = null;
      restaurantService.list(this.filter).then(res => {
        if(res.Code == 200 && res.Data && res.Data.List && res.Data.List.length > 0) {
          const data = res.Data;
          this.otherSenic = data.List;
        }
      })
    },
  },

}
</script>


// WEBPACK FOOTER //
// src/views/yuding/food-view.vue